export const BranchColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "email",
    title: "Email",
  },
  {
    id: "change_password",
    title: "Change Password",
  },
];
